import React from 'react';
import PropTypes from 'prop-types';

export const TabPanel = ({ children, tabindex, id }) => (
    <div role="tabpanel" tabIndex={tabindex} id={id}>
        { children }
    </div>
);

TabPanel.propTypes = {
    children: PropTypes.object.isRequired,
    tabindex: PropTypes.number,
    id: PropTypes.string
};

TabPanel.defaultProps = {
    tabindex: -1,
    id: 'tabpanel'
};

export default TabPanel;
